import {ContainerAlertTimelineEvent} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconBellFilled} from "@tabler/icons-react";

type Props = {
    event: ContainerAlertTimelineEvent;
};

export const ContainerAlertTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatchrequest.timeline.containeralert.title", "Container Alert Triggered")}</>
}

export const ContainerAlertTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="container-alert-high"
            radius="xl"
        >
            <IconBellFilled size={12}/>
        </ThemeIcon>
    )
}

export const ContainerAlertTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatchrequest.timeline.containeralert.summary", "{{alertType}} alert was triggered.", {
                    alertType: event.alertType ? t(event.alertType.displayValue.id, event.alertType.displayValue.defaultMessage) : t("common.unknown", "Unknown")
                })}
            </Text>

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

ContainerAlertTimelineItem.Title = ContainerAlertTimelineItemTitle
ContainerAlertTimelineItem.Bullet = ContainerAlertTimelineItemBullet;
